"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserEvent = void 0;
function browserEvent(target, ...args) {
    target.addEventListener(...args);
    return () => target.removeEventListener(...args);
}
exports.browserEvent = browserEvent;
//# sourceMappingURL=index.js.map